<template>
  <div id="about">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="main">
      <div class="headTit">
        帮助中心
        <span @click="Back()" class="backBtn">返回 ></span>
      </div>
      <div class="helpDetail">
        <div class="leftBox">
          <ul class="tab">
            <li @click="changeActive(index)" v-for="(item,index) in menu" :key="item.num"
              :class="[tabFlag === index? 'active': '']">{{item.name}}</li>
          </ul>
        </div>
        <div class="rightBox">
          <ul class="rightTab">
            <li @click="findDetail(item.id)" v-for="(item,index) in menu2" :key="item.id">{{item.title}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainHeader from '../../view/header'
export default {
  components: {
    mainHeader
  },
  data () {
    return {
      tabFlag: 0,
      menu: [],
      menu2: []
    }
  },
  methods: {
    logoutClick: function () {
      // this.$router.push({path: 'home'})
    },
    getList () {
      this.utils.GET(this.companyUrl + '/help/helpTypeList', res => {
        if (res.code === 0) {
          this.menu = res.data
          this.getDetailList(1)
        }
      })
    },
    getDetailList (type) {
      let src = type
      this.utils.GET(this.companyUrl + '/help/helpList?type=' + src, res => {
        if (res.code === 0) {
          this.menu2 = res.data
        }
      })
    },
    changeActive (index) {
      this.tabFlag = index
      this.getDetailList(this.tabFlag + 1)
    },
    findDetail (id) {
      this.$router.push({
        path: '/helpDetail',
        query: {
          id: id
        }
      })
    },
    Back () {
      window.history.go(-1)
    }
  },
  mounted () {
    this.getList()
    window.scroll(0, 0)
  }
}
</script>

<style lang="scss" scoped>
body {
  height: 100%;
  width: 100%;
  background: #f4f4f4;
}
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.main {
  font-size: 0;
  margin-top: 55px;
  display: block;
  width: 100%;
  box-sizing: border-box;
  .headTit {
    background: #ffffff;
    padding: 0 14px 0 14px;
    line-height: 50px;
    color: #000000;
    font-size: 15px;
    font-weight: bold;
    border-bottom: 10px solid #f4f4f4;
    .backBtn {
      font-size: 13px;
      color: #999999;
      float: right;
      font-weight: normal;
    }
  }
  .helpDetail {
    .leftBox {
      width: 104px;
      height: 100px;
      display: inline-block;
      vertical-align: top;
      .tab {
        width: 100%;
        li {
          position: relative;
          width: 100%;
          height: 42px;
          line-height: 42px;
          font-size: 12px;
          color: #000000;
          text-align: center;
        }
        li::after {
          content: "";
          position: absolute;
          width: 4px;
          height: 0px;
          background: #c41335;
          border-radius: 10px;
          left: 0;
          top: calc(50% - 7px);
        }
        li.active {
          background: #eeeeee;
          color: #c41335;
        }
        li.active::after {
          height: 15px;
          transition: all 0.3s;
        }
      }
    }
    .rightBox {
      display: inline-block;
      width: calc(100% - 104px);
      height: 100px;
      vertical-align: top;
      .rightTab {
        width: 100%;
        padding: 15px 20px 0 36px;
        li {
          list-style: disc;
          font-size: 12px;
          color: #000000;
          height: 42px;
          line-height: 16px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/helpCenter/helpCenter.vue